import { FeatureFlagKeys, FeatureFlags, FeatureFlagValue } from 'typings'
import { SET_FEATURE_FLAGS, SET_FEATURE_FLAGS_LOADED } from './actionTypes'

export type State = { loaded: boolean; values: FeatureFlags }

export const initialValues: Record<FeatureFlagKeys, FeatureFlagValue> = {
  [FeatureFlagKeys.STABLE_LOCALISATION_VERSION]: '',
  [FeatureFlagKeys.SEARCH_PAGE_SIZE]: 5,
}

const initialState: State = {
  loaded: false,
  values: initialValues,
}

const FeatureFlagsReducer = (
  state: State = initialState,
  action: ActionType,
): State => {
  switch (action.type) {
    case SET_FEATURE_FLAGS:
      return { ...state, values: { ...state.values, ...action.payload } }
    case SET_FEATURE_FLAGS_LOADED:
      return { ...state, loaded: true }
    default:
      return state
  }
}

export default FeatureFlagsReducer
